import * as React from 'react';
import styled from 'styled-components';
import { constants } from '@latitude/core';

// styled-components pass through any known HTML attributes to the DOM. Renaming some props to avoid this.

const StyledComponent = /*#__PURE__*/styled.h2.withConfig({
  displayName: "Heading__StyledComponent",
  componentId: "sc-1nwujmd-0"
})(["", ";", ";margin:", " 0 ", ";padding:0;font-size:", ";font-weight:", ";font-family:", ";line-height:", ";color:", ";text-align:", ";", ""], _ref => {
  let {
    cssDisplay
  } = _ref;
  return cssDisplay ? `display: ${cssDisplay};` : '';
}, _ref2 => {
  let {
    cssHeight
  } = _ref2;
  return cssHeight && `height: ${cssHeight};`;
}, _ref3 => {
  let {
    marginTop
  } = _ref3;
  return marginTop;
}, _ref4 => {
  let {
    marginBottom
  } = _ref4;
  return marginBottom;
}, _ref5 => {
  let {
    hVariant
  } = _ref5;
  return `${constants.HEADING[hVariant].FONT_SIZE.NORMAL}`;
}, _ref6 => {
  let {
    cssFontWeight,
    hVariant
  } = _ref6;
  return cssFontWeight || constants.HEADING[hVariant].FONT_WEIGHT;
}, _ref7 => {
  let {
    cssFontFamily,
    hVariant
  } = _ref7;
  return cssFontFamily || constants.HEADING[hVariant].FONT_FAMILY;
}, _ref8 => {
  let {
    hVariant
  } = _ref8;
  return `${constants.HEADING[hVariant].LINE_HEIGHT.NORMAL}`;
}, _ref9 => {
  let {
    cssColor
  } = _ref9;
  return cssColor;
}, _ref10 => {
  let {
    cssTextAlign
  } = _ref10;
  return cssTextAlign;
}, _ref11 => {
  let {
    hVariant,
    isResponsive
  } = _ref11;
  return isResponsive && `@media (min-width: ${constants.BREAKPOINT.SM}) {
      font-size: ${constants.HEADING[hVariant].FONT_SIZE.LARGE};
      line-height: ${constants.HEADING[hVariant].LINE_HEIGHT.LARGE};
    }`;
});
const Heading = _ref12 => {
  let {
    id,
    className,
    children,
    align = constants.ALIGN.LEFT,
    color = constants.COLOR.BODY,
    display = constants.DISPLAY.BLOCK,
    fontFamily,
    fontWeight,
    height,
    isResponsive = true,
    marginTop = constants.MARGIN.M0,
    marginBottom = constants.MARGIN.M32,
    variant = constants.HEADING_VARIANT.H2
  } = _ref12;
  const props = {
    id,
    className,
    children,
    cssColor: color,
    cssDisplay: display,
    cssFontFamily: fontFamily,
    cssFontWeight: fontWeight,
    cssTextAlign: align,
    cssHeight: height,
    marginTop,
    marginBottom,
    isResponsive,
    hVariant: variant
  };
  return /*#__PURE__*/React.createElement(StyledComponent, Object.assign({
    as: variant
  }, props), children);
};
const Heading1 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h1"
}));
const Heading2 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h2"
}));
const Heading3 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h3"
}));
const Heading4 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h4"
}));
const Heading5 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h5"
}));
const Heading6 = props => /*#__PURE__*/React.createElement(Heading, Object.assign({}, props, {
  variant: "h6"
}));
export { Heading, Heading1, Heading2, Heading3, Heading4, Heading5, Heading6 };